import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i2 from '@adeo/ngx-kozikaza-api';
import { BaseService, createSubResourceObservable, UserService, KOZIKAZA_API_OPTIONS } from '@adeo/ngx-kozikaza-api';
import { CommentService, PostService } from '@adeo/ngx-kozikaza-api/post';
import * as i1 from '@angular/common/http';

var ReportSubResource;
(function (ReportSubResource) {
    ReportSubResource.Author = 'author';
    ReportSubResource.Post = 'post';
    ReportSubResource.Comment = 'comment';
})(ReportSubResource || (ReportSubResource = {}));

class ReportService extends BaseService {
    platformId;
    injector;
    static endpoint = '/reports';
    getWebServiceName() {
        return 'ReportWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    getReports(subResources, options) {
        return this.getResources(ReportService.endpoint, subResources, options);
    }
    getReport(report, subResources, options) {
        return this.getResource(typeof report === 'string' ? report : report['@id'], subResources, options);
    }
    reportUser(userToBeReported, options) {
        // const body = JSON.stringify({user: typeof userToBeReported === 'string' ? userToBeReported : userToBeReported['@id']});
        return this.post(ReportService.endpoint, { user: typeof userToBeReported === 'string' ? userToBeReported : userToBeReported['@id'] }, options);
    }
    reportPost(postToBeReported, options) {
        // const body = JSON.stringify({post: typeof postToBeReported === 'string' ? postToBeReported : postToBeReported['@id']});
        return this.post(ReportService.endpoint, { post: typeof postToBeReported === 'string' ? postToBeReported : postToBeReported['@id'] }, options);
    }
    reportComment(commentToBeReported, options) {
        // const body = JSON.stringify({comment: typeof commentToBeReported === 'string' ?
        // commentToBeReported : commentToBeReported['@id']});
        return this.post(ReportService.endpoint, { comment: typeof commentToBeReported === 'string' ? commentToBeReported : commentToBeReported['@id'] }, options);
    }
    reportChatConversation(conversationToBeReportedId, userToBeReported, options) {
        return this.post(ReportService.endpoint, {
            conversation: conversationToBeReportedId,
            user: typeof userToBeReported === 'string' ? userToBeReported : userToBeReported['@id']
        }, options);
    }
    getSubResourceObservable(report, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case ReportSubResource.Author:
                if (report.author) {
                    return createSubResourceObservable(this.injector.get(UserService).getUser(report.author, subResourceRequest[1], options), options)
                        .pipe(map(user => {
                        report.author = user;
                        return report;
                    }));
                }
                return undefined;
            case ReportSubResource.Post:
                if (report.post) {
                    return createSubResourceObservable(this.injector.get(PostService).getPost(report.post, subResourceRequest[1], options), options)
                        .pipe(map(post => {
                        report.post = post;
                        return report;
                    }));
                }
                return undefined;
            case ReportSubResource.Comment:
                if (report.comment) {
                    return createSubResourceObservable(this.injector.get(CommentService).getComment(report.comment, subResourceRequest[1], options), options)
                        .pipe(map(comment => {
                        report.comment = comment;
                        return report;
                    }));
                }
                break;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ReportService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ReportService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ReportService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

const WEB_SERVICES = [
    ReportService,
];
class ReportApiModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ReportApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.8", ngImport: i0, type: ReportApiModule });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ReportApiModule, providers: [
            ...WEB_SERVICES,
        ] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ReportApiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    providers: [
                        ...WEB_SERVICES,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ReportApiModule, ReportService, ReportSubResource };
